import React from "react";
import { Button, Result } from "antd";
import { ReloadOutlined } from "@ant-design/icons";
import { formatDisplayError } from "../../utils/formatDisplayError";
import { getAssessmentTheme } from "../../hooks/useAssessmentTheme";

interface Props {
    title?: string;
    error?: unknown;
    onRetry?: () => void;
}

/**
 * Student-friendly failure UI for public school assessment entry routes.
 * Avoids the full developer error page and never surfaces "null" messages.
 */
export const SchoolAssessmentErrorFallback: React.FC<Props> = ({
    title = "Could not load assessment",
    error,
    onRetry,
}) => {
    const theme = getAssessmentTheme(null);
    const themeClass = `school-assessment-entry ${theme.cssClass}`;

    return (
        <div className={themeClass}>
            <div className="student-card">
                <Result
                    status="warning"
                    title={title}
                    subTitle={formatDisplayError(error, { publicAssessment: true })}
                    extra={
                        onRetry ? (
                            <Button
                                type="primary"
                                size="large"
                                icon={<ReloadOutlined />}
                                onClick={onRetry}
                            >
                                Try again
                            </Button>
                        ) : (
                            <Button
                                type="primary"
                                size="large"
                                icon={<ReloadOutlined />}
                                onClick={() => window.location.reload()}
                            >
                                Refresh page
                            </Button>
                        )
                    }
                />
            </div>
        </div>
    );
};

export default SchoolAssessmentErrorFallback;
